import BaseComponent from "../../../../baseComponent.js";

export default class LengthOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      textLength: props.textLength
    }
  }

  componentWillMount() {
    this.maxLength = 25;
  }

  onOptionValueClick(length) {
    this.props.onOptionValueClick(length);
    this.setState({textLength: length});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({textLength: nextProps.textLength});
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    let options = [
      <div className="item" key={0} onClick={() => this.onOptionValueClick(0)}>0</div>
    ];
    for (let i = 1; i <= this.maxLength; i++) {
      options.push(<div className="item" key={i} onClick={() => this.onOptionValueClick(i)}>{i}</div>);
    }
    return (
      <div>
        <div className='tw-option-container'>
          <div className='t-col single' data-cat='precision' ref="length"
               onClick={() => this.showOptions("lengthOptions")} style={{textAlign: 'left', padding: '0 10px'}}>
            Length: {this.state.textLength}
          </div>
        </div>
        <div className='option-list length' ref="lengthOptions"
             style={{width: '168px', height: '140px', overflowY: 'auto'}}>
          { options }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/lengthOptions.jsx